import {FilterService} from './services/filter.service';
import {FilterActionCreatorService} from './services/filter-action-creator.service';
import {FilterPanelComponent} from './components/filter-panel/filter-panel.component';
import {FilterUtils} from './utils/filter-utils';
import {FilterPanelService} from './services/filter-panel.service';
import {FilterPanelWrapperComponent} from './components/filter-panel-wrapper/filter-panel-wrapper.component';
import {FilterBucketComponent} from './components/filter-bucket/filter-bucket.component';
import {AppliedFilterComponent} from '@ispm/migration/components/aberrations/applied-filter/applied-filter.component';
import {FilterInputComponent} from './components/filter-panel/filterInput/filter-input.component';
import {RangeInputComponent} from './components/filter-panel/rangeInput/range-input.component';
import {DropdownInputComponent} from './components/filter-panel/dropdownInput/dropdown-input.component';
import {CheckboxlistIconInputComponent} from './components/filter-panel/checkboxlistIconInput/checkboxlistIcon-input.component';
import {FiltersSectionsComponent} from './components/filter-panel/filters-sections/filters-sections.component';
import {StatisticsSectionsComponent} from "./components/filter-panel/statistics-sections/statistics-sections.component";
import {StatisticsControlComponent} from "./components/filter-panel/statistics-control/statistics-control.component";
import {HistogramChartComponent} from "./components/filter-panel/histogram-chart/histogram-chart.component";
import {CheckBoxListComponent} from "./components/filter-panel/checkbox-list/checkBoxList.component";
import {DynamicWidthComponent} from "./components/filter-panel/dynamic-width/dynamicWidth.component";

export const filterComponents = [
    FilterPanelComponent,
    FiltersSectionsComponent,
    StatisticsSectionsComponent,
    StatisticsControlComponent,
    HistogramChartComponent,
    CheckBoxListComponent,
    DynamicWidthComponent,
    AppliedFilterComponent,
    FilterPanelWrapperComponent,
    FilterBucketComponent,
    FilterInputComponent,
    RangeInputComponent,
    DropdownInputComponent,
    CheckboxlistIconInputComponent
];

export const filterServices = [FilterService, FilterActionCreatorService, FilterPanelService];
export const filterUtils = [FilterUtils];

